<template>
 <Card title="crm.pipeline.activity.history">
   <template #cardToolbar>
    <div class="d-flex justify-content-end align-items-center">
      <NewActivityButton v-if="$can(abilities.CREATE_ACTIVITY)" :activity-types="activityTypes" @handleClick="toggleActivityModal" :isDisabled="pipeline?.status == 'WON' || pipeline?.status == 'LOST' || pipeline.status == 'ARCHIVED'"/>
    </div>
   </template>
   <template #cardBody>
     <Card v-if="isLoading" class="card shadow-none">
       <template #cardBody>
         <div class="min-h-50px d-flex align-items-center justify-content-center">
           <div class="spinner-grow text-secondary" role="status">
             <span class="visually-hidden">{{$t('loading')}}</span>
           </div>
         </div>
       </template>
     </Card>
     <Card v-else-if="!opportunityActivities.length" class="card shadow-none">
       <template #cardBody>
        <div class="row g-6 g-xl-9 text-center justify-content-center align-items-center">
          <div class=" text-center ">
            <div class="pt-8 ">
              <Img filename="empty.png" alt=""
                    class="mw-100 h-100px h-sm-150px" />
            </div>
            <h2 class="fw-bolder mb-0">{{ $t('crm.pipeline.activity.no_found') }}</h2>
          </div>
        </div>
       </template>
     </Card>
     <div v-else class="m-0">
       <div class="timeline timeline-border-dashed">
         <TimelineItem
            v-for="(activity, index) in opportunityActivities"
            :key="index"
            :id="activity.id"
            :created-at="activity.created_at"
            :type="activity.type_activity"
            :detail="activity.detail"
            :files="activity.files"
            :pipeline="pipeline"
            @toggleActivityEditModal="handleEditModalToggle"
         />
       </div>
     </div>
   </template>
 </Card>
  <ActivityModal
      id="opportunity-activity-modal"
      :isEdit="isEdit"
      :form-data="formActivityData"
      @activityCreated="loadOpportunityActivities"
      @activityUpdated="loadOpportunityActivities"
  />
</template>

<script setup>
import {onMounted, ref, computed, defineProps, watch} from "vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import Card from "@/Modules/CRM/components/Card";
import TimelineItem from "@/Modules/CRM/components/TimelineItem";
import NewActivityButton from "@/Modules/CRM/components/NewActivityButton";
import ActivityModal from "@/Modules/CRM/components/Modals/Activity/ActivityModal";
import abilities from "@/composables/abilities";
import {useHasAbility} from "@/composables/hasAbility";
import Img from "@/components/Img.vue";

const store = useStore()
const route = useRoute()
const { can } = useHasAbility()

const props = defineProps({
  reload: { type: Number, default: 1 },
  filter: {
    type: Array,
    default: () => ([])
  },
  pipeline: Object
})

const isLoading = ref(false)

const formActivityData = ref({
  opportunity_id: route.params.id,
  activity_id: '',
  type_activity: '',
  type_activity_id: '',
  files: [],
  type: null,
  title: null,
  priority: null,
  dateTime: null,
  note: '',
  date: '',
  time: '',
  remind_frequency_count: null,
  remind_frequency: null
})

const isEdit = ref(false)

const opportunityActivities = computed(() => store.getters['activity/opportunityActivities'])
const activityTypes = computed(() => store.getters['activity/activityTypes'])

function handleEditModalToggle(id, type) {
  isEdit.value = true
  const activity = opportunityActivities.value.find(el => el.id === id)
  formActivityData.value = {
    opportunity_id: route.params.id,
    activity_id: id,
    type_activity: type,
    type_activity_id: activity.type_activity_id,
    files: activity.files || [],
    type: activity?.detail?.type || null,
    title: activity?.detail?.title || null,
    priority: activity?.detail?.priority,
    dateTime: activity?.detail?.dateTime || null,
    duration: activity?.detail?.duration || null,
    note: activity?.detail?.note || '',
    date: activity?.detail?.dateTime?.split(' ')[0] || '',
    time:  activity?.detail?.dateTime?.split(' ')[1] || '',
    detach_files: [],
    remind_frequency_count: activity?.detail?.remind_frequency_count || null,
    remind_frequency: activity?.detail?.remind_frequency || null
  }
  $('#opportunity-activity-modal').modal('toggle')
}

function toggleActivityModal({id, activityType}) {
  isEdit.value = false
  formActivityData.value = {
    opportunity_id: route.params.id,
    type_activity: activityType,
    type_activity_id: id,
    files: [],
    type: null,
    title: null,
    priority: null,
    dateTime: null,
    note: '',
    date: '',
    time: '',
    detach_files: [],
    remind_frequency_count: null,
    remind_frequency: null
  }
  $('#opportunity-activity-modal').modal('toggle')
}

watch(() => props.reload, (value) => {
  loadData()
})

const loadOpportunityActivities = () => {
  if(can(abilities.VIEW_ACTIVITY)) {
    store.dispatch('activity/loadOpportunityActivities', route.params.id)
  }
  formActivityData.value = {
    opportunity_id: route.params.id,
    activity_id: '',
    type_activity: '',
    type_activity_id: '',
    files: [],
    type: null,
    title: null,
    priority: null,
    dateTime: null,
    note: '',
    date: '',
    time: '',
    detach_files: [],
    remind_frequency_count: null,
    remind_frequency: null
  }
}

function loadData() {
  isLoading.value = true
  Promise.all([
    loadOpportunityActivities(),
    store.dispatch('activity/loadEmailActivityTypeEnum'),
    store.dispatch('pipelines/loadPipelinePrioritiesEnum'),
    store.dispatch('activity/loadCallActivityTypeEnum'),
    store.dispatch('pipelines/loadActivityRemindEnum')
  ]).finally(() => isLoading.value = false)
}

onMounted(() => {
  loadData()
})


</script>

